const items = [
	{
		id: 1,
		status: 1,
		name: "payment.pay"
	},
	{
		id: 3,
		status: 3,
		name: "payment.indebit"
	}
];

export default items;